{
  "partner_overview_page": {
    "title": "Good to see you, {firstName}!",
    "description": "We're excited to have you on board as an official SparkLayer partner. How can we help you today?",
    "footer": "Learn more about SparkLayer",
    "refer_action": "Refer a customer",
    "cards": {
      "refer": {
        "title": "Refer a customer",
        "body": "Now you have access to our partner portal, you can easily refer customers and earn commission.",
        "action": "Refer a customer"
      },
      "guides": {
        "title": "Best-practice guides",
        "body": "Learn how you can deliver a best-practice B2B experience and download our latest 1-page guides.",
        "action": "View all resources"
      },
      "slack": {
        "title": "Join us on Slack",
        "body": "Get access to your exclusive SparkLayer Slack channel to talk with us.",
        "action": "Learn more"
      },
      "support": {
        "title": "Raise a support ticket",
        "body": "Have a technical or general question that you need answering?",
        "action": "Raise a ticket"
      }
    },
    "test_mode": {
      "title": "SparkLayer test mode",
      "body": "As a partner, you get access to a special SparkLayer test mode account where you can try out features and familiarise yourself with how it works."
    }
  }
}
